module.exports = __webpack_public_path__ + "static/media/typographic-scale-example-sampler.74b7f0b0.jpg";